import React from "react";
import useGame from "../../context/game";

const Loader = () => {
  const { loading, developMode } = useGame();
  if (!loading || developMode) return;
  return (
    <div className="loader-wrapper">
      <div className="loader-spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  );
};

export default Loader;
